module.exports = __webpack_public_path__ + "static/media/7c2a5fde.jpg";